/** Configuration File
 **/

module.exports = {
    backend: 'https://tagmanagerapi.mwancloud.com/'
}
